import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicModule } from '@ionic/angular';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { HttpClientModule } from '@angular/common/http';
import { NgxsSelectSnapshotModule } from '@ngxs-labs/select-snapshot';
import { NgxActioncableService } from '@csventures/ngx-actioncable';
import { NgxsResetPluginModule } from 'ngxs-reset-plugin';
import { IonicStorageModule } from '@ionic/storage';

import { AppComponent } from './app.component';
import { StoreModule } from '../store/store.module';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { TranslocoRootModule } from './transoloco.config';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    TranslocoRootModule,
    StoreModule,
    NgxsLoggerPluginModule.forRoot({
      disabled: !environment.DEV
    }),
    NgxsSelectSnapshotModule.forRoot(),
    NgxsResetPluginModule.forRoot()
  ],
  providers: [NgxActioncableService],
  bootstrap: [AppComponent]
})
export class AppModule {}
